
import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Filter } from 'lucide-react';

// Define allowed topic types to match what's in the database/api
type TopicOptions = 'guide' | 'performance' | 'trading_strategy' | 'advisor';

interface TopicFilterSelectProps {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
}

export const TopicFilterSelect: React.FC<TopicFilterSelectProps> = ({ 
  value, 
  onChange 
}) => {
  const handleValueChange = (selected: string) => {
    onChange(selected === 'all' ? undefined : selected);
  };

  return (
    <div className="flex items-center">
      <Filter className="mr-2 h-4 w-4 text-muted-foreground" />
      <Select
        value={value || 'all'}
        onValueChange={handleValueChange}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Filter by AI type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All AI Types</SelectItem>
          <SelectItem value="guide">Guide AI</SelectItem>
          <SelectItem value="performance">Performance AI</SelectItem>
          <SelectItem value="trading_strategy">Trading Strategy AI</SelectItem>
          <SelectItem value="advisor">Advisor AI</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
